<template>
  <v-app :style="cssProps">

    <!-- Brand configuration loader-->
    <v-dialog v-if="ciLoading || logOutLoading" value="true" fullscreen persistent hide-overlay>
      <v-card height="100%">
        <v-container fill-height v-if="true" :fullscreen="$vuetify.breakpoint.xsOnly">
          <v-layout row justify-center align-center>
            <v-progress-circular :size="50"
                                 :width="3"
                                 color="grey"
                                 indeterminate
            />
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>

    <vue-headful
      :title="ci.name"
      :description="ci.name"
    />

    <!--Mobile Option Sheet-->
    <v-bottom-sheet
      v-model="bottomSheetState"
    >
      <v-list>
        <v-list-tile @click.native="saveAll()">
          <v-list-tile-title>
            <v-icon color="secondary">save</v-icon>
            SAVE
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click.native="deleteAll()">
          <v-list-tile-title>
            <v-icon color="red">delete</v-icon>
            DELETE
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title>
            <v-spacer/>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>

    </v-bottom-sheet>

    <!--Mobile Navigation-->
    <v-navigation-drawer v-if="user != null"
                         persistent
                         :mini-variant="miniVariant"
                         :clipped="clipped"
                         v-model="drawer"
                         enable-resize-watcher
                         fixed
                         app
    >
      <v-list>
        <v-list-tile
          value="true"
          v-for="(item, i) in enabledModules"
          :key="i"
          router
          :to="item.link"
        >

          <v-list-tile-action>
            <v-icon v-html="item.icon"/>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"/>
          </v-list-tile-content>
        </v-list-tile>


        <v-list-tile>
          <v-list-tile-action>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title/>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider/>
        <v-spacer/>


        <v-list-tile
          value="true"
          v-for="(setting, i) in settings"
          :key="10000"
          router
          :to="setting.link"
        >

          <v-list-tile-action>
            <v-icon>{{ setting.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ setting.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-for="(logout, i) in logouts" :key="20000" @click="onSingOut">
          <v-list-tile-action>
            <v-icon>{{ logout.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ logout.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>


    </v-navigation-drawer>

    <!--Desktop Navigation-->
    <v-toolbar v-if="user != null"
               app
               :clipped-left="clipped"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"/>

      <v-btn icon @click.stop="miniVariant = !miniVariant">
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"/>
      </v-btn>

      <v-spacer/>

      <v-toolbar-title id="search-text" v-if="$vuetify.breakpoint.mdAndUp">

        <v-autocomplete

          append-icon=""
          prepend-inner-icon="search"
          label="Search"
          solo
          class="mt-2"
          flat
          clearable

        >

          <template slot="no-data">
            <v-list-tile>
              <v-list-tile-title>
                Search for <strong>Inquiries</strong>, <strong>Invoices</strong> or
                <strong>Offers</strong>...
                <!-- <router-link :to="{ name: 'Inquiries', params: { id: 1 } }">Navigate to Page2</router-link>-->
              </v-list-tile-title>
            </v-list-tile>
          </template>


        </v-autocomplete>

      </v-toolbar-title>


      <v-btn color="grey--text"
             v-show="$vuetify.breakpoint.smAndDown"
             icon @click.stop="">
        <v-icon>search</v-icon>
      </v-btn>

      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template v-slot:activator="{ on }">

          <v-btn color="primary--text"
                 icon @click.native="menu = true">
            <v-icon color="grey" v-show="!showNotificationBadge">notifications_active</v-icon>
            <v-badge v-show="showNotificationBadge" right>
              <span slot="badge">5</span>
              <v-icon>notifications_active</v-icon>
            </v-badge>
          </v-btn>

        </template>

        <v-card>
          <v-list>
            <v-list-tile avatar>

              <v-list-tile-content>
                <v-list-tile-title>Notifications</v-list-tile-title>
                <!-- <v-list-tile-sub-title>Notifications Panel</v-list-tile-sub-title>-->
              </v-list-tile-content>

              <v-list-tile-action>
                <!--                                <v-btn
                                                        :class="fav ? 'red&#45;&#45;text' : ''"
                                                        icon
                                                        @click="fav = !fav"
                                                >
                                                    <v-icon>notifications_active</v-icon>
                                                </v-btn>-->

                <v-btn

                  icon
                >
                  <v-icon color="grey">notifications_active</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <v-divider/>

          <v-list>
            <!--                        <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch v-model="message" color="purple"></v-switch>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Enable messages</v-list-tile-title>
                                    </v-list-tile>

                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch v-model="hints" color="purple"></v-switch>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Enable hints</v-list-tile-title>
                                    </v-list-tile>-->

          </v-list>

          <v-list>

            <v-list-tile>
              <v-list-tile-title center>No unread notifications</v-list-tile-title>
            </v-list-tile>


          </v-list>


          <!--                    <v-card-actions>
                                  <v-spacer></v-spacer>

                                  <v-btn flat @click="menu = false">Cancel</v-btn>
                                  <v-btn color="primary" flat @click="menu = false">Save</v-btn>
                              </v-card-actions>-->
        </v-card>
      </v-menu>


      <v-toolbar-title v-show="$vuetify.breakpoint.lgAndUp">
        <img alt="logo" v-bind:src="ci.brand_configurations_ci.main_logo" style="padding-top: 16px; width: 140px">
      </v-toolbar-title>
      <v-toolbar-title v-show="$vuetify.breakpoint.md">
        <img alt="logo" v-bind:src="ci.brand_configurations_ci.main_logo"
             style="padding-top: 12px; margin-right: 0px; width: 130px">
      </v-toolbar-title>
      <v-toolbar-title v-show="$vuetify.breakpoint.sm">
        <img alt="logo" v-bind:src="ci.brand_configurations_ci.main_logo"
             style="padding-top: 12px; margin-right: 0px; width: 120px">
      </v-toolbar-title>
      <v-toolbar-title v-show="$vuetify.breakpoint.xs">
        <img alt="logo" v-bind:src="ci.brand_configurations_ci.main_logo"
             style="padding-top: 12px; margin-right: 0px; width: 100px">
      </v-toolbar-title>


    </v-toolbar>


    <!--Content-->
    <v-content>
      <router-view/>
    </v-content>
    <!--Footer-->

    <!--Api Success Snackbar-->
    <v-snackbar
      v-model="success.show"
      color="primary"
      :multi-line="false"
      :timeout="4000"
      :vertical="false"
      top
      auto-height
    >
      {{ success.text }}
      <v-btn
        dark
        flat
        @click="success.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <!--Api Success Snackbar-->

    <!--Api Error Snackbar-->
    <v-snackbar
      v-model="showError"
      color="error"
      :multi-line="true"
      :timeout="0"
      :vertical="true"
      top
      auto-height
    >
      {{ getNetworkError }}
      <v-btn
        dark
        flat
        @click="clearError"
      >
        Close
      </v-btn>
    </v-snackbar>
    <!--Api Error Snackbar-->

  </v-app>
</template>

<script>
  import {
    Settings,
    BrandConfigurationCI
  } from './store/namespace-helper'

  export default {
    mounted () {
      this.getCI()
    },
    data () {
      return {
        menu: false,
        clipped: false,
        drawer: true,
        fixed: false,
        showNotificationBadge: false,
        settings: [
          {title: 'Settings', icon: 'fas fa-cog', link: '/settings/account'}
        ],
        logouts: [
          {title: 'Logout', icon: 'fas fa-sign-out-alt'}
        ],
        miniVariant: true,
        right: true,
        rightDrawer: false,
        title: 'Logo',
        logoImage: '../../static/Logo_Detech.png'
      }
    },
    computed: {
      ci () {
        let defaultTheme = this.$store.getters[BrandConfigurationCI.getters.defaultCI]
        if (defaultTheme.brand_configurations_ci.primary_color) {
          this.$vuetify.theme.primary = '#' + defaultTheme.brand_configurations_ci.primary_color
        }
        if (defaultTheme.brand_configurations_ci.secondary_color) {
          this.$vuetify.theme.secondary = '#' + defaultTheme.brand_configurations_ci.secondary_color
        }
        return defaultTheme
      },
      user () {
        return this.$store.getters.user
      },
      error () {
        return this.$store.getters.error
      },
      getNetworkError () {
        if (this.$store.getters[Settings.getters.getNetworkError] !== null) {
          return this.$store.getters[Settings.getters.getNetworkError].message
        } else {
          return ''
        }
      },
      showError () {
        if (this.$store.getters[Settings.getters.getNetworkError] !== null) {
          return true
        } else {
          return false
        }
      },
      success () {
        return this.$store.getters.success
      },
      loading () {
        return this.$store.getters.loading
      },
      bottomSheetState: {
        // getter
        get: function () {
          return this.$store.getters.getbottomSheetState
        },
        // setter
        set: function (newValue) {
          return this.$store.dispatch('openCloseBottomSheet')
        }
      },
      cssProps () {
        return {
          '--secondary-color': this.$vuetify.theme.secondary,
          '--primary-color': this.$vuetify.theme.primary
        }
      },
      ciLoading () {
        return this.$store.getters.ciLoading
      },
      logOutLoading () {
        return this.$store.getters.logoutLoading
      },
      enabledModules () {
        var items = [
          {title: 'Dashboard', icon: 'fas fa-chart-pie', link: '/dashboard', enabled: true},
          {title: 'Inquiries', icon: 'fas fa-briefcase', link: '/inquiries', enabled: true},
          {title: 'Offers', icon: 'fab fa-buffer', link: '/offers', enabled: true},
          {title: 'Purchase Orders', icon: 'fas fa-file-alt', link: '/purchaseOrders', enabled: true},
          {title: 'Procurements', icon: 'fas fa-shopping-cart', link: '/procurements', enabled: true},
          {title: 'Supplier Orders', icon: 'fas fa-truck-moving', link: '/supplierOrders', enabled: true},
          {title: 'Follow-up', icon: 'fas fa-hands', link: '/followUp', enabled: true},
          {title: 'Invoice', icon: 'fas fa-receipt', link: '/invoice', enabled: true},
          {
            title: 'Product Listings',
            icon: 'fas fa-globe',
            link: '/productListings',
            enabled: this.productListingEnabled
          }
          /*     {title: 'Customers', icon: 'group', link: '/customers'} */
          /*                    {title: 'Logistics', icon: 'local_shipping', link: '/logistics'},
                              {title: 'Accounting', icon: 'attach_money', link: '/accounting'} */
        ]
        return items.filter(module => module.enabled === true)
      },
      productListingEnabled () {
        if (this.ci &&
        this.ci.brand_configurations_ci &&
        this.ci.brand_configurations_ci.product_listing) {
          return this.ci.brand_configurations_ci.product_listing
        } else {
          return false
        }
      }

    },
    methods: {
      onSingOut () {
        this.$store.dispatch('logout', '')
      },
      saveAll () {
        alert('save')
      },
      deleteAll () {
        alert('delete')
      },
      clearError () {
        this.$store.dispatch(Settings.actions.clearNetworkError)
      },
      getCI () {
        this.$store.dispatch('getCI')
      }
    },
    name: 'App'
  }
</script>


<style scoped>

  #search-text {
    width: 25%;
  }


</style>


<style>

  .editr--toolbar {
    /*background: #f6f6f6;*/
    background-color: var(--secondary-color) !important;
    border-bottom: 1px solid #e4e4e4;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: auto;
    flex-wrap: wrap;
  }

  .editr--toolbar a svg {
    fill: white;
  }

  .editr--toolbar a.vw-btn-separator {
    width: 1px;
    margin: 0 10px;
    display: none;
  }

  .v-window__container--is-active {
    height: auto !important;
  }

  .v-window__container {
    height: auto !important;

  }

  .cropper-dashed {
    border: 0 dashed #000;
    display: block;
    opacity: 0.9;
    position: absolute;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue